exports.onInitialClientRender = () => {
  window.scrollTo(0, 0);

  // Preserve query parameters on initial page load
  // Check if query params exist in the actual URL but might be stripped by Gatsby
  if (typeof window !== 'undefined' && window.location.search) {
    // Store the original query params before Gatsby potentially strips them
    const originalSearch = window.location.search;
    const originalPath = window.location.pathname;

    // Use a small delay to check if Gatsby stripped them after initial render
    setTimeout(() => {
      if (window.location.search !== originalSearch) {
        // Query params were stripped, restore them
        window.history.replaceState({}, '', originalPath + originalSearch);
      }
    }, 0);
  }
};

exports.onRouteUpdate = ({ location }) => {
  // Preserve query parameters when Gatsby's router updates
  // This ensures query params are not stripped during navigation or page reload
  if (typeof window !== 'undefined') {
    const expectedUrl = location.pathname + (location.search || '');
    const currentUrl = window.location.pathname + (window.location.search || '');

    // If query params exist in location object but not in actual URL, restore them
    if (location.search && !window.location.search) {
      window.history.replaceState({}, '', expectedUrl);
    } else if (expectedUrl !== currentUrl && location.search) {
      // Ensure query params match what Gatsby's router expects
      window.history.replaceState({}, '', expectedUrl);
    }
  }
};

exports.shouldUpdateScroll = ({ routerProps }) => {
  // Skip scroll behavior for blog pages
  return routerProps?.location?.pathname?.includes('/blog') ? false : true;
};
